/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable max-len */
/* eslint-disable import/extensions */
import React, { createContext, useEffect, useReducer } from 'react';
import Router, { useRouter } from 'next/router';
import { Button, Modal } from 'react-bootstrap';
import { FaCheck, FaXmark } from 'react-icons/fa6';
import Head from 'next/head';
import TagManager from '@sooro-io/react-gtm-module';
import 'bootstrap/dist/css/bootstrap.min.css';
import Layout1 from '@/components/layouts/site';
import Layout2 from '@/components/layouts/crm';
import Layout3 from '@/components/layouts/profile';
import Layout4 from '@/components/layouts/landpage';
import Layout5 from '@/components/layouts/classifieds';
import { help, layout, messages, notification } from '@/helpers/index';
import 'react-image-gallery/styles/css/image-gallery.css';
import '../styles/fonts.css';
import '../styles/globals.css';
import '../styles/ra-styles.css';
import '../styles/style.css';
import '../styles/blog.css';

export const MessagesContext = createContext(messages.init());
export const NotificationContext = createContext(notification.init());

const layouts = {
  site: Layout1,
  crm: Layout2,
  profile: Layout3,
  landpage: Layout4,
  classifieds: Layout5,
};

Router.events.on('routeChangeStart', (route) => {
  if (layout.route.get() !== route) {
    if (route.indexOf('/crm') === 0 || route.indexOf('/perfil') === 0) {
      help.close();
    }
    layout.route.set(route);
    layout.loading(true);
  }
});
Router.events.on('routeChangeComplete', (route) => {
  layout.route.set(route);
  const skip = ['/crm/cadastrar-parceiro', '/perfil/comprar-credito', '/perfil/produtos'];
  if ((!route.includes('/perfil') && !route.includes('/crm')) || skip.includes(route)) {
    layout.loading(false);
  }
  if (route === '/carrinho/checkout' || route === '/carrinho/pagamento' || route === '/crm/cadastrar-parceiro') {
    layout.cart.show(false);
  }
});
Router.events.on('routeChangeError', () => layout.loading(false));

export default function AboutCarApp({ Component, pageProps }) {
  const router = useRouter();
  const canonicalUrl = `https://aboutcar.com.br${router.asPath.split('?')[0]}`;
  const [stateMessages, dispatchMessages] = useReducer(messages.reduce, messages.init());
  const [stateNotification, dispatchNotification] = useReducer(notification.reduce, notification.init());
  const Layout = layouts[Component.layout || 'site'] || ((children) => ({ children }));
  messages.configure(dispatchMessages);
  notification.configure(dispatchNotification);
  const onShow = () => { layout.focus(stateNotification.type === 'alert' ? 'alertClose' : 'confirmNo'); };
  const onHide = () => { if (stateNotification.cancel) { stateNotification.cancel(); } notification.close(); };
  const onYes = () => { if (stateNotification.yes) { stateNotification.yes(); } notification.close(); };
  const onNo = () => { if (stateNotification.no) { stateNotification.no(); } notification.close(); };
  const getVariant = () => stateNotification.type === 'delete' ? 'danger' : 'primary';
  useEffect(() => {
    TagManager.initialize({ gtmId: 'GTM-PLJXHTB' });
  }, []);
  return (
    <MessagesContext.Provider value={{ stateMessages, dispatchMessages }}>
      <Layout code={Component.code} enableMessages={Component.enableMessages}>
        <Head>
          <meta charSet="utf-8" />
          <title key="title">Consulta de Histórico Veicular por Placa | AboutCar</title>
          <base href="/" />
          <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=5" />
          <meta name="description" content="Consulta de placa, histórico de veículo, leilão, restrições, sinistro, segurança, roubo e furto, aceitação em seguradoras, quilometragem, recall, proprietários e muito mais." key="description" />
          <meta name="keywords" content="consulta veicular, consulta placa, consultar placa, consulta histórico, consultar histórico, histórico veículo, verificar placa, leilão de veículos, restrições de veículo, roubo/furto, consulte, veículo, descubra, saiba, saiba agora, consulta, busca, pesquisa, puxa, checa, consultar, buscar, pesquisar, puxar, checar, veículo, veiculo, carro, moto, caminhão, caminhao, histórico, historico, históricos, historicos, leilão, leilao, histórico em leilão, indício, sinistro, indício de sinistro, roubo, furto, roubo e furto, seguradora, aceitação em seguradoras, km, quilometragem, remarketing, recall, chassi, placa, fipe, tabela, decodificador, motor, precificador, renavam, procedencia, restrições, restricoes, proprietários, indício, aceitação em seguradoras, consulta veículo grátis, consulta grátis, consulta de graça, puxar gratis, checar gratis, consulta veiculo gratis, puxar placa, puxar placa de carro, puxar placa de moto, puxar placa de caminhao, buscar veiculo pela placa, muito mais" key="keywords" />
          <meta name="author" content="AboutCar" key="author" />
          <meta name="robots" content="index, follow" key="robots" />
          <meta name="revisit-after" content="1 day" key="revisit-after" />
          <meta name="language" content="Portuguese" key="language" />
          <meta name="generator" content="N/A" />
          <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
          <link rel="canonical" href={canonicalUrl} key="canonical" />
          <link rel="icon" type="image/png" href="/assets/images/favicon.png" />
          <meta property="og:locale" content="pt_BR" key="og:locale" />
          <meta property="og:type" content="website" key="og:type" />
          <meta property="og:title" content="Consulta de Histórico Veicular por Placa | AboutCar" key="og:title" />
          <meta property="og:description" content="Consulta de placa, histórico de veículo, leilão, restrições, sinistro, segurança, roubo e furto, aceitação em seguradoras, quilometragem, recall, proprietários e muito mais." key="og:description" />
          <meta property="og:url" content={canonicalUrl} key="og:url" />
          <meta property="og:site_name" content="AboutCar" key="og:site_name" />
          <meta property="og:image" content="https://aboutcar.com.br/assets/images/aboutcar-classifieds.png" key="og:image" />
          <meta property="og:image:secure_url" content="https://aboutcar.com.br/assets/images/aboutcar-classifieds.png" key="og:image:secure_url" />
          <meta property="og:image:type" content="image/png" key="og:image:type" />
          <meta property="og:image:width" content="1200" key="og:image:width" />
          <meta property="og:image:height" content="630" key="og:image:height" />
          <meta name="twitter:card" content="summary_large_image" key="twitter:card" />
          <meta name="twitter:title" content="Consulta de Histórico Veicular por Placa | AboutCar" key="twitter:title" />
          <meta name="twitter:description" content="Consulta de placa, histórico de veículo, leilão, restrições, sinistro, segurança, roubo e furto, aceitação em seguradoras, quilometragem, recall, proprietários e muito mais." key="twitter:description" />
          <meta name="twitter:image" content="https://aboutcar.com.br/assets/images/aboutcar-classifieds.png" key="twitter:image" />
        </Head>
        <Component {...pageProps} />
        <NotificationContext.Provider value={{ stateNotification, dispatchNotification }}>
          {stateNotification.show && (
            <Modal show onShow={onShow} onHide={onHide} backdrop="static" aria-labelledby="contained-modal-title-vcenter" centered>
              <Modal.Header closeButton className={stateNotification.class}>
                <h2 className="text-center not-printable featurette-heading mt-1">
                  {stateNotification.title || (stateNotification.type === 'confirm' ? 'Confirmação' : 'Atenção')}
                </h2>
              </Modal.Header>
              <Modal.Body>
                <span dangerouslySetInnerHTML={{ __html: stateNotification.message }} />
              </Modal.Body>
              <Modal.Footer>
                {['delete', 'confirm'].includes(stateNotification.type) && (
                  <>
                    <Button id="confirmYes" variant={getVariant()} size="sm" className="shadow-sm" onClick={onYes}>
                      <FaCheck className="me-1" />
                      Sim
                    </Button>
                    <Button id="confirmNo" variant="light" size="sm" className="shadow-sm" onClick={onNo}>
                      <FaXmark className="me-1" />
                      Não
                    </Button>
                  </>
                )}
                {stateNotification.type === 'alert' && (
                  <Button id="alertClose" variant="light" size="sm" className="shadow-sm" onClick={notification.close}>
                    <FaXmark className="me-1" />
                    Fechar
                  </Button>
                )}
              </Modal.Footer>
            </Modal>
          )}
        </NotificationContext.Provider>
      </Layout>
    </MessagesContext.Provider>
  );
}
